import {
  Button,
  Card,
  Col,
  Form,
  Placeholder,
  Row,
} from "react-bootstrap";
import { ButtonSpinner, FloatInput } from "src/componentes";
import CadastroInicialUsuarioCode from "./CadastroInicialUsuario.Code";

export const CadastroInicialUsuarioView = () => {
  const {
    loading,
    submitting,
    register,
    errors,
    handleSubmit,
    onSubmit,
    handleVoltar,
  } = CadastroInicialUsuarioCode();

  return (
    <Card className="shadow-sm mb-5">
      <Card.Header className="py-3">
        <h5 className="mb-0 text-primary fw-bold">
          Passo 2 de 2: Dados do Usuário
        </h5>
        <small className="text-muted">
          Confirme e preencha seus dados pessoais para vincular seu usuário à empresa
        </small>
      </Card.Header>
      <Card.Body className="p-4">
        <Form noValidate onSubmit={handleSubmit(onSubmit)}>
          {!loading ? (
            <>
              <Row>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <FloatInput
                    label="Nome"
                    errorsMessage={errors.nome}
                    registerField={register("nome")}
                    inputMask="capitalizar"
                  />
                </Col>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <FloatInput
                    label="Sobrenome"
                    errorsMessage={errors.sobrenome}
                    registerField={register("sobrenome")}
                    inputMask="capitalizar"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <FloatInput
                    label="Data de Nascimento"
                    errorsMessage={errors.dataNascimento}
                    registerField={register("dataNascimento")}
                    inputMask="data"
                  />
                </Col>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <FloatInput
                    label="CPF"
                    errorsMessage={errors.documento}
                    registerField={register("documento")}
                    inputMask="cpf"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <FloatInput
                    label="Telefone"
                    errorsMessage={errors.numeroTelefone}
                    registerField={register("numeroTelefone")}
                    inputMask="fone"
                  />
                </Col>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <FloatInput
                    label="E-mail"
                    errorsMessage={errors.email}
                    registerField={register("email")}
                    inputMask="minusculas"
                  />
                </Col>
              </Row>
              <div className="d-flex justify-content-between align-items-center mt-4 pt-2">
                <Button
                  type="button"
                  variant="outline-secondary"
                  size="lg"
                  onClick={handleVoltar}
                  disabled={submitting}
                >
                  &larr; Voltar para Empresa
                </Button>
                <ButtonSpinner
                  type="submit"
                  variant="success"
                  size="lg"
                  loading={submitting}
                >
                  Concluir Cadastro
                </ButtonSpinner>
              </div>
            </>
          ) : (
            <Placeholder animation="glow">
              <Placeholder xs={12} size="lg" className="mb-3" />
              <Placeholder xs={12} size="lg" className="mb-3" />
              <Placeholder xs={12} size="lg" className="mb-3" />
            </Placeholder>
          )}
        </Form>
      </Card.Body>
    </Card>
  );
};

export default CadastroInicialUsuarioView;
